var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Loading from "../Loading/Loading";
/**
 *  To use font awesome icons
 */
const FAIcon = (_a) => {
    var _b;
    var { icon, type, className, fixedWidth, size, spin, srText, isLoading, addMarginRight } = _a, otherProps = __rest(_a, ["icon", "type", "className", "fixedWidth", "size", "spin", "srText", "isLoading", "addMarginRight"]);
    const classNameParts = [];
    if (icon == null) {
        if (console.error) {
            console.error("FAIcon - no icon provided. Icon is a required prop. To render a blank icon, pass in an empty string for the icon.");
        }
    }
    else {
        // Does the icon start with fal/fas/fab ? If so, just add that to the class instead.
        // kept as a string instead of a boolean in case we want to have the type prop override the iconPrefix.
        const iconPrefix = (_b = icon.match(/fa[^-]/)) === null || _b === void 0 ? void 0 : _b[0];
        if (iconPrefix) {
            if (console.warn) {
                console.warn(`FAIcon - icon prop '${icon}' contained icon prefix.  This will still work, but use the type prop instead and just pass in the name of the icon (eg 'paper-plane') if possible.`);
            }
            classNameParts.push(icon);
        }
        else {
            classNameParts.push(type || "fal");
            classNameParts.push(icon ? `fa-${icon}` : "");
        }
    }
    classNameParts.push(className !== null && className !== void 0 ? className : "");
    classNameParts.push(size ? "fa-" + size : "");
    classNameParts.push(spin ? "fa-spin" : "");
    classNameParts.push(fixedWidth ? "fa-fw" : "");
    classNameParts.push(addMarginRight ? "mr-1" : "");
    return isLoading ? (_jsx(Loading, { size: size, className: className, addMarginRight: addMarginRight })) : (_jsxs(_Fragment, { children: [_jsx("span", Object.assign({}, otherProps, { className: classNameParts.join(" "), "aria-hidden": true })), srText && _jsx("span", { className: "sr-only", children: srText })] }));
};
export default FAIcon;
